module.exports = __webpack_public_path__ + "static/media/03.c3f6e257.jpg";